export const FULLSCREEN_DIALOG_PAPER_SX = {
  '& .MuiDialog-paper': {
    m: 0,
    p: 0,
    width: '100%',
    height: '100%',
    maxWidth: 'none',
    maxHeight: 'none',
    borderRadius: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
} as const;

export const FULLSCREEN_DIALOG_HEADER_SX = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  minHeight: 48,
  height: 48,
  px: 1,
  py: 0,
  borderBottom: 1,
  borderColor: 'divider',
} as const;

export const FULLSCREEN_DIALOG_TITLE_SX = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  maxWidth: '50%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'center',
} as const;

export const FULLSCREEN_DIALOG_BUTTON_SX = {
  minWidth: 'auto',
  minHeight: 28,
  px: 1.5,
  py: 0.5,
  fontSize: '0.8125rem',
  textTransform: 'none',
} as const;

export const FULLSCREEN_DIALOG_ICON_BUTTON_SX = {
  width: 32,
  height: 32,
} as const;
